import React from 'react'

import {
  Box,
  FlexDirection,
  AlignItems,
  Color,
  Display3,
  Heading4,
  JustifyContent,
} from '@gousto-internal/citrus-react'

interface Props {
  credit: string
}

export const CreditBlob: React.FC<Props> = ({ credit }) => (
  <Box
    display="flex"
    flexDirection={FlexDirection.Column}
    bg={Color.Primary_600}
    alignItems={AlignItems.Center}
    justifyContent={JustifyContent.Center}
    borderRadius="round"
    paddingV={4}
    paddingH={4}
    height={['96px', '96px', '120px', '120px']}
    width={['96px', '96px', '120px', '120px']}
  >
    <Display3 size={[9, 9, 13, 13]} color={Color.White}>
      {credit}
    </Display3>
    <Heading4 color={Color.White}>credit</Heading4>
  </Box>
)
